import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ComputedFrom } from '@certemy/common';
import { findAndReplaceURL } from 'utils/helpers';
import { STEP_TYPES } from 'constants/status.constants';

export interface RegistryTableOrder {
  id: string;
  type: string;
}

@Component({
  selector: 'cm-registry-table',
  templateUrl: 'registry-table.component.html',
  styleUrls: ['registry-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistryTableComponent {
  @Input() registries;
  @Input() order: RegistryTableOrder;
  @Input() rowsClickable: boolean;
  @Input() publicView = false;
  @Input() showDemandPsv = false;
  @Output() orderChange = new EventEmitter<RegistryTableOrder>();
  @Output() viewDetails = new EventEmitter<any>();
  @Output() onRowClick = new EventEmitter();
  @Output() onOpenHistory = new EventEmitter<{ stepId: STEP_TYPES; acronym: string }>();
  @Output() initPsv = new EventEmitter<boolean>();

  @ComputedFrom('registries')
  get headers() {
    return this.registries[0].rows;
  }
  @ComputedFrom('registries')
  get isRegistries() {
    return this.registries && this.registries.length;
  }
  private skipNextRowClick = false;

  findAndReplaceLinks = findAndReplaceURL;
  noContentConfig = {
    src: '/assets/images/public-registry/no-results/no-results.png',
    srcset: `/assets/images/public-registry/no-results/no-results.png 1x,
                 /assets/images/public-registry/no-results/no-results@2x.png 2x,
                 /assets/images/public-registry/no-results/no-results@3x.png 3x`,
    title: 'No results',
    subtitle: 'There are no credentials to be shown',
  };

  readonly ACRONYM_SORT_ID = 'acronym';

  onOrderChange(entry, type) {
    this.orderChange.emit({
      id: entry.sort_id,
      type,
    });
  }

  onRowClicked(row) {
    if (!this.skipNextRowClick) {
      this.onRowClick.emit(row);
    }
    this.skipNextRowClick = false;
  }

  onSkipNextRowClick() {
    this.skipNextRowClick = true;
  }

  showHistory(rowData, historyType = 26) {
    this.onSkipNextRowClick();
    if (!rowData.acronym) {
      return;
    }
    this.onOpenHistory.emit({ stepId: historyType, acronym: rowData.acronym });
  }

  initiatePsv(event: boolean): void {
    this.initPsv.emit(event);
  }
}
